import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import classes from './tooltip.module.scss';
export const Tooltip = ({ title, children, placement = "right", tooltipClassNames }) => {
	const [isOver, setIsOver] = useState(false)
	let el = React.Children.only(children);
	const ref = useRef();
	useEffect(() => {
		const hideTooltip = () => {
			if (isOver) {
				setIsOver(false)
			}
		}
		window.addEventListener("scroll", hideTooltip);
		return () => window.removeEventListener("scroll", hideTooltip)
	}, [isOver])
	el = React.cloneElement(el, {
		ref,
		onMouseOver: (e) => {
			setIsOver(true)
		},
		onMouseOut: () => {
			setIsOver(false)
		}
	})
	const boundries = isOver && ref.current && ref.current.getBoundingClientRect();
	const tooltip = ReactDOM.createPortal(

		boundries ?
			<div className={classNames(classes['tooltip'], classes[placement])} style={{
				top: boundries.top,
				left: boundries.left,
				'--el-width': boundries.width + 'px'
			}}>
				<span className={classNames(tooltipClassNames)}>{title}</span>
			</div> : <></>, document.getElementsByTagName('body')[0])
	return <>{el}{tooltip}</>
}
